import * as Store from './feedbackStore'
import { all, takeEvery, put, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { FeedbackModel } from '../models/FeedbackModels';
import * as moment from 'moment';
import * as api from '../../api/feedbackApi'
import { PagedResultData } from '../../common/models/PagingModels';


export function* watchFeedbackSagas() {
    yield all([
        takeEvery(Store.ActionType.RequestFeedback, fetchFeedback),
        takeEvery(Store.ActionType.SetRead, setReadFlow)
    ]);
}

function* fetchFeedback(action: Store.RequestFeedbackAction) {
    try {
        const data: PagedResultData<FeedbackModel> = yield call(api.fetchFeedback, action.paging);
        yield put(Store.actionCreators.receivedFeedback(data))
    }
    catch (error) {
        console.log(error);
        yield put(Store.actionCreators.receivedFeedback(undefined))
    }
}

function* setReadFlow(action: Store.SetReadAction) {
    yield call(api.setFeedbackRead, action.feedbackId);

    if (action.paging) {
        yield put(Store.actionCreators.requestFeedback(action.paging));
    }
}


// WEBPACK FOOTER //
// ./src/admin/store/feedbackSagas.ts